import React, { Suspense } from 'react';
import { Inconsistencies } from '../inconsistencies';

export const Information: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <>
      <ul>
        <li>
          The Final Terms and, where required, the summary and its translations have to be sent in one single file:
          <ul>
            <li>
              One single PDF document (including the Final Terms, the summary and the translations of the summary in one single searchable
              PDF)
            </li>
          </ul>
        </li>
        <li>
          For Final Terms with multiple securities, please indicate the first security and then press "+" to add additional securities.
        </li>
        <li>Size limit: 50 MB total size</li>
      </ul>

      <Suspense fallback="loading">
        <Inconsistencies></Inconsistencies>
      </Suspense>
    </>
  );
};
